export default {
  storePanelAllLabelNew: {
    id: 'store_panel_all_label_new',
    defaultMessage: 'see all',
  },
}
